import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { FormGroup, UntypedFormBuilder, Validators } from '@angular/forms';
import { AranModalService } from '@aran-client/aran-web-ui-toolkit';
import { tap } from 'rxjs';
import { appInfo } from 'src/app/shared/constants/app-info.constant';
import { routeMetaData } from 'src/app/shared/constants/route-metadata.constant';
import { NavigationService } from 'src/app/shared/services/navigation/navigation.service';
import { StoreHelperService } from 'src/app/shared/services/store-helper/store-helper.service';
import { LoginForCodeType, LoginType } from 'src/app/shared/types/auth.types';
import { ErrorMessages } from 'src/app/shared/utils/error-message.utils';
import { AuthAction } from 'src/app/store/auth/auth.action';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
})
export class LoginComponent implements OnInit {
  @ViewChild('modalTemplate') modalTemplate!: TemplateRef<any>;

  routeMetaData = routeMetaData;
  appInfo = appInfo;

  form!: FormGroup<any>;

  errorMessages = ErrorMessages;

  constructor(
    private formBuilder: UntypedFormBuilder,
    private aranModalService: AranModalService,
    private navigation: NavigationService,
    private storeHelperService: StoreHelperService
  ) {}

  ngOnInit(): void {
    this.form = this.formBuilder.group({
      email: this.formBuilder.control(null, [
        Validators.required,
        Validators.email,
      ]),
      password: this.formBuilder.control(null, Validators.required),
      code: this.formBuilder.control(null),
    });
  }

  onEnterPressed(): void {
    this.login();
  }

  login(): void {
    if (this.form.invalid) {
      this.form.markAllAsTouched();
      return;
    }

    const formValue = this.form.value;
    delete formValue.code;
    var body = this.form.value as LoginForCodeType;

    this.storeHelperService
      .getAllDispatchAndSelect(new AuthAction.Login(body))
      .pipe(
        tap(() => {
          this.openDialog();
        })
      )
      .subscribe();
  }

  loginConfirm(): void {
    if (this.form.invalid) {
      this.form.markAllAsTouched();
      return;
    }

    var body = this.form.value as LoginType;

    this.storeHelperService
      .getAllDispatchAndSelect(new AuthAction.LoginConfirm(body))
      .pipe(
        tap(() => {
          this.aranModalService.hide();
          this.navigation.goToMyAccount();
        })
      )
      .subscribe();
  }

  openDialog() {
    this.aranModalService.show(this.modalTemplate, '600px');
  }
}
